import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  LocalProvaRequestDTO,
  LocalProvaResponseDTO
} from '../models/local-prova.model';

@Injectable({
  providedIn: 'root'
})
export class LocalProvaService {
  private apiUrl = `${environment.apiUrl}/admin/locais-prova`;

  constructor(private http: HttpClient) {}

  /**
   * Criar Local de Prova
   * POST /api/admin/locais-prova
   */
  criarLocalProva(data: LocalProvaRequestDTO): Observable<LocalProvaResponseDTO> {
    return this.http.post<LocalProvaResponseDTO>(this.apiUrl, data);
  }

  /**
   * Atualizar Local de Prova
   * PUT /api/admin/locais-prova/{id}
   */
  atualizarLocalProva(id: number, data: LocalProvaRequestDTO): Observable<LocalProvaResponseDTO> {
    return this.http.put<LocalProvaResponseDTO>(`${this.apiUrl}/${id}`, data);
  }

  /**
   * Buscar Local de Prova por ID
   * GET /api/admin/locais-prova/{id}
   */
  buscarLocalProvaPorId(id: number): Observable<LocalProvaResponseDTO> {
    return this.http.get<LocalProvaResponseDTO>(`${this.apiUrl}/${id}`);
  }

  /**
   * Listar Locais de Prova por Edital
   * GET /api/admin/locais-prova/edital/{editalId}
   */
  listarLocaisPorEdital(editalId: number): Observable<LocalProvaResponseDTO[]> {
    return this.http.get<LocalProvaResponseDTO[]>(`${this.apiUrl}/edital/${editalId}`);
  }

  /**
   * Listar Locais de Prova por Cidade
   * GET /api/admin/locais-prova/cidade/{cidadeId}
   */
  listarLocaisPorCidade(cidadeId: number): Observable<LocalProvaResponseDTO[]> {
    return this.http.get<LocalProvaResponseDTO[]>(`${this.apiUrl}/cidade/${cidadeId}`);
  }

  /**
   * Deletar Local de Prova
   * DELETE /api/admin/locais-prova/{id}
   */
  deletarLocalProva(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
